import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { ProfileService } from '../service/profile.service';

@Injectable()
export class SacadoGuard implements CanActivate {

  constructor(
    private profileService: ProfileService
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return this.profileService.temAcessoPortalSacado();
  }
}